import './details';



// WEBPACK FOOTER //
// ./src/app/pages/documents/templates/workflows/index.js